import React from 'react';
import { useGetDiscountsQuery } from '../../Discounts/Service/discountsApi';
import { mapBookingDiscountsLookupData } from './discountsLookupApi.contract';

export const useGetBookingDiscountsLookupQuery = () => {
  const queryResult = useGetDiscountsQuery();

  const data = React.useMemo(
    () => mapBookingDiscountsLookupData(queryResult.data),
    [queryResult.data]
  );

  return {
    ...queryResult,
    data,
  };
};
